import axiosInstance from './axiosInstance';

export const forgotPasswordApi  = (data)         => axiosInstance.post('/auth/forgot-password', data);
export const verifyResetOTPApi  = (data)         => axiosInstance.post('/auth/verify-reset-otp', data);
export const resetPasswordApi   = (data)         => axiosInstance.patch('/auth/reset-password', data);
export const changePasswordApi  = (data)         => axiosInstance.patch('/auth/change-password', data);
